"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9491],{

/***/ 19491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DimmedLayer": function() { return /* binding */ DimmedLayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84808);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60374);
/* harmony import */ var _logic_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42125);




var DimmedLayer = function() {
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var isDimmedLayerActive = (0,_logic_state__WEBPACK_IMPORTED_MODULE_1__/* .useDimmedLayer */ .bi)(function(s) {
        return s.isDimmedLayerActive;
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
    return isDimmedLayerActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        open: isDimmedLayerActive,
        sx: {
            zIndex: theme.zIndex.tooltip + 1,
            backgroundColor: theme.palette.backdrop.dimmedBackgroundColor,
            backdropFilter: "none"
        }
    });
};


/***/ })

}]);